module.exports = __webpack_public_path__ + "static/media/login.bedf31a0.jpg";